<template>
  <div class="p-6">
    <div class="max-w-xl mx-auto">
      <h1 class="mb-6 text-2xl font-bold">
        Configure integrations
      </h1>

      <div class="grid overflow-hidden bg-white divide-y rounded shadow">
        <div v-for="integration in integrations" :key="integration.key">
          <button class="flex items-center w-full p-6 hover:bg-gray-100" :class="{ 'bg-gray-100': selected = integration.key }" @click="selected = integration.key">
            <img :src="integration.image" alt="" class="flex-none h-5">
            <div class="px-6 text-lg font-medium">
              {{ integration.name }}
            </div>
          </button>
          <Collapse :active="selected === 'webfleet'">
            <div class="p-12">
              <div class="p-6 border rounded bg-gray-50">
                Ensure the user whose details you enter here has <strong>WEBFLEET.connect API Access</strong>: 
                <a href="https://portals.webfleet.com/s/article/How-to-enable-WEBFLEET-connect-access-for-a-WEBFLEET-user?language=en_us" target="_blank">How to enable WEBFLEET.connect access for a WEBFLEET user <fa :icon="['far', 'external-link']" /></a>
              </div>
              <form @submit.prevent="submitWebfleet()">
                <fieldset class="mt-6 form-group">
                  <label class="flex items-center form-label">
                    <toggle :value.sync="webfleet.integration_webfleet" class="mr-2" />
                    Enable WEBFLEET Integration
                  </label>
                </fieldset>
                <div :class="{ 'opacity-50': !webfleet.integration_webfleet }">
                  <fieldset class="form-group">
                    <label for="webfleet_account" class="form-label">Account</label>
                    <input id="webfleet_account" type="text" class="py-3 form-input" v-model="webfleet.webfleet_account" :disabled="!webfleet.integration_webfleet">
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="webfleet_username" class="form-label">Username</label>
                    <input id="webfleet_username" type="text" class="py-3 form-input" v-model="webfleet.webfleet_username" :disabled="!webfleet.integration_webfleet">
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="webfleet_password" class="form-label">Password</label>
                    <input id="webfleet_password" type="password" class="py-3 form-input" v-model="webfleet.webfleet_password" :disabled="!webfleet.integration_webfleet">
                  </fieldset>
                </div>
                <button type="submit" class="w-full mt-2 btn btn-lg btn-primary" v-submitting="submitting">
                  Save Details
                </button>
              </form>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnboardingIntegrations',

  data () {
    return {
      submitting: false,
      errors: [],
      selected: null,
      webfleet: {
        integration_webfleet: false,
        webfleet_account: '',
        webfleet_username: '',
        webfleet_password: '',
      },
      integrations: [
        { 
          key: 'webfleet',
          name: 'Webfleet Solutions',
          image: '/images/integrations/webfleet-logo.png'
        }
      ]
    }
  },

  methods: {
    async submitWebfleet () {
      if (!this.webfleet.webfleet_account) {
        array.push({ 
          field: 'webfleet_account', 
          rule: 'subdomain_required', 
          message: `You must enter a WEBFLEET account`
        })
      }

      if (!this.webfleet.webfleet_username) {
        array.push({ 
          field: 'webfleet_username', 
          rule: 'webfleet_username_required', 
          message: `You must enter a WEBFLEET username`
        })
      }

      if (!this.webfleet.webfleet_password) {
        array.push({ 
          field: 'webfleet_password', 
          rule: 'webfleet_password_required', 
          message: `You must enter your WEBFLEET password`
        })
      }

      if (!this.errors.length) {
        await this.updateAccount(this.webfleet, 'WEBFLEET')
      }
    },

    async updateAccount (form, integration) {
      try {
        this.submitting = true
        await this.$api.patch(`account/${this.$route.params.account}/accounts/${this.$parent.account.id}`, {
          ...this.$parent.account,
          ...form
        })
        await this.$store.dispatch('syncUser', this)
        this.$toasted.show(`${integration} added.`)
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
        this.selected = null
      }
    }
  }
}
</script>